import * as React from 'react';
import { observer } from 'mobx-react';
import dashboardWrapper from '~/wrappers/dashboard';
import { t } from '~/i18n';

import HealthcareProviderCreateContainer from '~/containers/HealthcareProviders/HealthcareProviderCreate';
import { Panel } from '@ixicare/ui';
import { ProfileTable } from '~components/Tables/ProfileTables/ProfileTable';
import { healthcareProviderTableConfig } from '~components/Tables/ProfileTables/tableConfig';
import { ProfileType } from '@ixicare/resources';
import { useStores } from '~store/utils';

const EXTRA_PROFILE_TYPES_BY_USER_TYPE: Partial<Record<ProfileType, ProfileType[]>> = {
  [ProfileType.Installer]: [ProfileType.Installer],
  [ProfileType.WatcherrEmployee]: [ProfileType.Installer, ProfileType.WatcherrEmployee],
};

const HealthcareProvidersPage: React.FC = observer(() => {
  const { auth, permissions } = useStores();
  const extra = auth.userType ? EXTRA_PROFILE_TYPES_BY_USER_TYPE[auth.userType] : undefined;
  const profileTypes = extra ? [ProfileType.HealthcareProvider, ...extra] : undefined;

  return (
    <>
      <Panel>
        <ProfileTable
          config={healthcareProviderTableConfig}
          profileType={ProfileType.HealthcareProvider}
          profileTypes={profileTypes}
          editPermissions={permissions.has('can_edit_all_profiles')}
          deletePermissions={permissions.has('can_delete_all_profiles')}
          loginAsPermissions={permissions.has('can_login_as_profile')}
        />
      </Panel>
      {permissions.has('can_create_profiles') && <HealthcareProviderCreateContainer />}
    </>
  );
});

export default dashboardWrapper(HealthcareProvidersPage, t('menu.dashboard.healthcareProviders'));
